const comparisonOperatorsHash = {
        'is_less_than': function(a: string, b: string) { return a < b; },
        'is_greater_than': function(a: string, b: string) { return a > b; },
        'is_greater_than_or_equal_to': function(a: string, b: string) { return a >= b; },
        'is_less_than_or_equal_to': function(a: string, b: string) { return a <= b; },
        'is_equal_to': function(a: string, b: string) { return a === b; },
        'is_not_equal_to': function(a: string, b: string) { return a !== b; },
    };

const matchesFilterType = (filter_type: 'is_equal_to', value: string, value_to_filter: string) => {
	return comparisonOperatorsHash[filter_type](value, value_to_filter)
}

export const shouldShow = (cmCondition: any, values: any) => {
	const value = values.form_answers?.find((fa: any) => fa.custom_module_id === cmCondition.conditional_custom_module_id)?.answer

	return matchesFilterType(cmCondition.filter_type, value, cmCondition.value_to_filter)
}

